export const ADOBE_ACCESS_TOKEN_LS_KEY = 'adobe_access_token';

export const getAdobeAuthUrl = (): string => {
  const currentUrl = globalThis?.location?.href;
  const state = 'Active';
  const scope = 'learner:read';
  const responseType = 'CODE';

  return `https://captivateprime.adobe.com/oauth/o/authorize?client_id=${process.env
    .ADOBE_CLIENT_ID!}&redirect_uri=${currentUrl}&state=${state}&scope=${scope}&response_type=${responseType}`;
};

export interface AdobeTokenResponse {
  access_token: string;
}

export const fetchAdobeToken = async (code: string): Promise<AdobeTokenResponse> => {
  const url = 'https://learningmanager.adobe.com/oauth/token';

  const body = new URLSearchParams({
    client_id: process.env.ADOBE_CLIENT_ID!,
    client_secret: process.env.ADOBE_CLIENT_SECRET!,
    code: code,
  });

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: body.toString(),
  });

  if (!response.ok) {
    throw new Error(`Error fetching Adobe token: ${response.status} - ${response.statusText}`);
  }

  const data = await response.json();

  return data;
};

export const getAdobeToken = (): string | null => {
  // Check if we're in a browser environment (SSR-safe)
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return null;
  }

  return localStorage.getItem(ADOBE_ACCESS_TOKEN_LS_KEY);
};
